<div class="wrap" *ngIf="!send">
    <h4>Resend password creation email</h4>
    <p>
        Do you want to resend the email?</p>

    <div class="btn_action">
        <button class="back" (click)="dialogRef.close()"> Cancel</button>
        <button class="confirm" (click)="sendMailPassword()"> Confirm</button>
    </div>
</div>

<app-validation-animation *ngIf="send" [text]="'
The email has been sent successfully'"></app-validation-animation>